import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { Dropdown, Option } from '@xingternal/text-field';

import { trackFieldFocus } from '@/domain/job-application/helpers';
import { useCountries } from '@/domain/job-application/hooks';
import { LIFormFieldValues, LOFormFieldValues } from '@/domain/job-application/types';

type Props = {
  control: Control<LOFormFieldValues | LIFormFieldValues>;
};

const trackCountryCodeFocus = (): void => {
  trackFieldFocus({
    isAutofilled: true,
    isMandatory: false,
    fieldName: 'country_code',
  });
};

export const CountryCodeField: React.VFC<Props> = ({ control }) => {
  const intl = useIntl();
  const countries = useCountries();

  return (
    <Controller
      name="countryCode"
      control={control}
      render={({ field: { ref, ...fieldProps }, fieldState }) => (
        <Dropdown
          size="medium"
          {...fieldProps}
          placeholder={intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_LO_COUNTRY_CODE_LABEL' })}
          aria-label={intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_LO_COUNTRY_CODE_LABEL' })}
          innerRef={ref as unknown as React.RefObject<HTMLElement>}
          error={!!fieldState.error}
          helperText={
            fieldState?.error
              ? intl.formatMessage({ id: 'JOBS_POSTING_APPLY_FORM_LO_COUNTRY_CODE_FIELD_ERROR' })
              : undefined
          }
          onFocus={trackCountryCodeFocus}
        >
          {countries.map(({ name, dialCode, countryCode }) => (
            <Option key={countryCode} value={countryCode}>{`${name} (+${dialCode})`}</Option>
          ))}
        </Dropdown>
      )}
    />
  );
};
